<!--
sorry for the duplicated code, but I didn't find a better way:
* angular does not support conditional use of directives, and if the routerLink is present it overwrite the href even if the link is undefined, "" or []
* routerLink must be applied directly on an <a> tag to render a href, so we can't externalize the visual part into a separate component
-->

@if (deactivated) {
  <!-- Difference to Stack @TODO After BAG 51 -->
  <a [target]="target" [ngClass]="classes" [title]="tooltipKey ? (tooltipKey | translate) : ''"
     class="vertical-menu-item" [class.main]="!parent" [class.heading]="children">
    <ng-template [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ }">
    </ng-template>
  </a>
} @else {
  @if (href) {
    <a [href]="href" [attr.target]="target" [ngClass]="classes"
       [title]="tooltipKey ? (tooltipKey | translate) : ''"
       (click)="click()" class="vertical-menu-item" [class.main]="!parent" [class.heading]="children">
      <ng-template [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ }">
      </ng-template>
    </a>
  } @else if (url) {
    @if (children) {
      <a [target]="target" [ngClass]="classes"
         [title]="tooltipKey ? (tooltipKey | translate) : ''"
         (click)="click()" class="vertical-menu-item" [class.main]="!parent" [class.heading]="children">
        <ng-template [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ }">
        </ng-template>
      </a>
    } @else {
      <a [routerLink]="url" [queryParams]="queryParameter" [target]="target" [ngClass]="classes"
         [title]="tooltipKey ? (tooltipKey | translate) : ''"
         (click)="click()" class="vertical-menu-item" [class.main]="!parent" [class.heading]="children">
        <ng-template [ngTemplateOutlet]="item" [ngTemplateOutletContext]="{ }">
        </ng-template>
      </a>
    }
  }
}

<ng-template #item>
  @if (icon) {
    <span class="fas {{icon}} fa-fw text-primary" aria-hidden="true"></span>
  }
  <span [class.ms-2]="icon">{{ labelKey | translate }}</span>
  @if (children) {
    <i class="fas fa-chevron-right fa-fw" aria-hidden="true"></i>
  }
</ng-template>

@if (children) {
  <div class="heading-children" [ngClass]="classes">
    <ng-content></ng-content>
  </div>
}
